"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionDirection = exports.TransactionStatus = void 0;
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["CREATED"] = "created";
    TransactionStatus["STARTED"] = "started";
    TransactionStatus["IN_PROGRESS"] = "in_progress";
    TransactionStatus["PENDING"] = "pending";
    TransactionStatus["REJECTED"] = "rejected";
    TransactionStatus["ABORTED"] = "aborted";
    TransactionStatus["CANCELLED"] = "cancelled";
    TransactionStatus["COMPLETED"] = "completed";
    //Additional statuses for standing orders' transactions
    TransactionStatus["MISSED"] = "missed";
    TransactionStatus["PARTIALLY_PAID"] = "partially_paid";
    TransactionStatus["UNABLE_TO_CHECK"] = "unable_to_check";
})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
var TransactionDirection;
(function (TransactionDirection) {
    TransactionDirection["INCOMING"] = "incoming";
    TransactionDirection["OUTGOING"] = "outgoing";
})(TransactionDirection = exports.TransactionDirection || (exports.TransactionDirection = {}));
